<template>
  <div>
    <baseFrame
      saveText="保存"
      submitText="提交"
      clearText=""
      @save="addStocktakingResults"
      @submit="submitStocktakingResults"
      @cancel="handleToReceivableList"
      :saveLoading="saveLoading"
      :submitLoading="submitLoading"
      :showCtrls="true"
      :infosArr="infosArr"
      :id="receivableStocktakingPlan.code"
      idText="盘点单号">
      <div slot="content">
        <lk-card title="">
          <div style="display:flex;align-items:center;">
            <div>商品搜索:</div>
            <lk-input style="width: 300px;margin-left:10px;" placeholder='支持商品编码、通用名、商品名' v-model="searchContent"></lk-input>
            <div style="margin-left:20px">
              <lk-button type='primary' @click="handleSearch">查询</lk-button>
              <lk-button style="margin-left:10px;" @click="handleReset">重置</lk-button>
            </div>
          </div>
        </lk-card>
        <lk-card title="盘点结果信息">
          <div class="requireStocktakingRecord">
            <dtp-table class="mb16" border :columns="columns" :data="tableData"></dtp-table>
            <div class="mb16" style="text-align:right">
              <lk-page
                :total="count"
                :current="page"
                :page-size="size"
                :page-size-opts="[50]"
                size="small"
                show-elevator
                show-total
                transfer
                @on-change="handlePage">
              </lk-page>
            </div>
          </div>
        </lk-card>
      </div>
    </baseFrame>
  </div>
</template>
<script>
import baseFrame from '@/components/frame/BaseFrame.vue';
import inventoryManage from '@/services/inventoryManage';
import utils from '@/libs/utils';
import DtpTable from '@/components/DtpTable';

export default {
  components: {
    baseFrame,
    DtpTable,
  },
  data() {
    return {
      infosArr: [],
      searchContent: null,
      saveLoading: false,
      submitLoading: false,
      receivableStocktakingPlan: {},
      columns: [
        {
          title: '序号',
          width: 60,
          render: (h, params) => h('span', params.index + (this.page - 1) * this.size + 1),
        },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '通用名', key: 'approvedName', minWidth: 110 },
        { title: '商品名', key: 'goodsName', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 110 },
        {
          title: '实盘数量',
          key: 'realCount',
          minWidth: 130,
          fixed: 'right',
          render: (h, { row }) => h('lk-input-number', {
            props: {
              value: row.realCount,
              min: 0,
              max: 9999999.99,
              precision: 2,
              activeChange: false,
            },
            on: {
              'on-change': (value) => {
                this.changedData.push({ id: row.id, value });
                row.realCount = value;
              },
            },
          }),
        },
        {
          title: '盘点人员', key: 'operatorName', minWidth: 110, fixed: 'right',
        },
      ],
      tableData: [],
      tableDataAll: [],
      searchData: [],
      changedData: [], // 记录改动的哪些数据，id和实盘数量值.
      page: 1,
      size: 50,
      count: 0,
      lastPage: 1,
    };
  },
  computed: {},
  methods: {
    handleSearch() {
      this.toUpdateTableData();
      this.searchData = [];
      this.page = 1;
      if (this.searchContent && this.searchContent !== 0) {
        this.tableDataAll.forEach((item) => {
          if (item.drugSerialCode.indexOf(this.searchContent) !== -1 || item.goodsName.indexOf(this.searchContent) !== -1 || item.approvedName.indexOf(this.searchContent) !== -1) {
            this.searchData.push(item);
          }
        });
        this.count = this.searchData.length;
        this.getPageData(1, this.searchData);
      } else {
        this.searchData = this.tableDataAll;
        this.count = this.tableDataAll.length;
        this.getPageData(1, this.searchData);
      }
    },
    getPageData(val, searchData) {
      let pageData = [];
      if (searchData) {
        const currentNum = (val - 1) * this.size; // 起始数据
        pageData = this.searchData.slice(currentNum, currentNum + this.size);
      } else {
        const currentNum = (val - 1) * this.size; // 起始数据
        pageData = this.tableDataAll.slice(currentNum, currentNum + this.size);
      }
      this.tableData = pageData;
    },
    handleReset() {
      this.searchContent = null;
    },
    getData() {
      const params = {
        id: Number.parseInt(this.$route.params.id, 10),
        nameMix: this.searchContent,
      };
      inventoryManage.getReceivableInputInfo(params)
        .then((res) => {
          if (res.data.status === 200) {
            const result = res.data.data;
            this.tableDataAll = result.receivableStocktakingDetailList || [];
            this.count = this.tableDataAll.length;
            this.receivableStocktakingPlan = result.receivableStocktakingPlan || {};
            this.infosArr = utils.setInfoArr(this.receivableStocktakingPlan, 'input');
            this.getPageData(1); // 获取分页数据
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
    },
    getStocktakingResults(isSubmit = true) {
      this.toUpdateTableData();
      let errorMsg = '';
      const invalidList = []; // 记录所有不合格的数据在第几行，便于提示信息展示。
      const stocktakingResults = [];
      for (let i = 0, len = this.tableDataAll.length; i < len; i++) {
        if (Number.isNaN(Number(this.tableDataAll[i].realCount))) {
          errorMsg = '实盘数量必须为数字';
          break;
        }
        if (Number(this.tableDataAll[i].realCount) < 0) {
          errorMsg = '实盘数量不能为负数';
          invalidList.push((i + 1));
          break;
        }
        const {
          id, cid, planId, realCount, receivablesNum, goodsStoreId, goodsBatchNumber, operatorId, operatorName,
        } = this.tableDataAll[i];
        if (isSubmit) {
          stocktakingResults.push({
            id,
            cid,
            planId,
            receivablesNum,
            goodsStoreId,
            goodsBatchNumber,
            operatorId,
            operatorName,
            realCount: realCount || 0,
          });
        } else {
          stocktakingResults.push({
            id,
            realCount: realCount || 0,
          });
        }
      }
      if (errorMsg) {
        this.$Message.error(`${errorMsg}, 请修改第${invalidList}行`);
        return false;
      }
      return stocktakingResults;
    },
    addStocktakingResults() {
      const receivableStocktakingDetailList = this.getStocktakingResults(false);
      if (!receivableStocktakingDetailList) {
        return;
      }
      const params = {
        receivableStocktakingDetailList,
        receivableStocktakingPlan: {
          id: this.receivableStocktakingPlan.id,
        },
      };
      this.saveLoading = true;
      inventoryManage.saveReceivableInput(params)
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('保存成功');
            this.handleToReceivableList();
          } else {
            this.$Message.error(res.data.error);
          }
          this.saveLoading = false;
        })
        .catch((err) => {
          this.saveLoading = false;
          utils.handleError(err);
        });
    },
    submitStocktakingResults() {
      const receivableStocktakingDetailList = this.getStocktakingResults();
      if (!receivableStocktakingDetailList) {
        return;
      }
      const params = {
        receivableStocktakingDetailList,
        receivableStocktakingPlan: {
          id: Number.parseInt(this.$route.params.id, 10),
          status: this.receivableStocktakingPlan.status,
        },
      };
      this.submitLoading = true;
      inventoryManage.submitReceivableInput(params)
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('提交成功');
            this.handleToReceivableList();
          } else {
            this.$Message.error(res.data.error);
          }
          this.submitLoading = false;
        })
        .catch((err) => {
          this.submitLoading = false;
          utils.handleError(err);
        });
    },
    handleToReceivableList() {
      this.$router.push({
        name: 'receivableList',
      });
    },
    // 切换页面
    handlePage(val) {
      this.toUpdateTableData();
      this.page = val;
      if (this.searchData.length) {
        this.getPageData(val, this.searchData);
      } else {
        this.getPageData(val);
      }
    },
    toUpdateTableData() {
      if (!this.changedData.length) {
        return;
      }
      this.changedData.forEach((item) => {
        const obj = this.tableDataAll.find(dataItem => item.id === dataItem.id);
        obj.realCount = item.value;
      });
      this.changedData = [];
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
</style>
